export const unlockableInitialState = {
  preparingUnlock: false,
  preparedUnlock: false,
  prepareUnlockError: null,
  unlocking: false,
  unlocked: false,
  unlockError: null,
};
